export const generateErrorContent = (errObject) => {

  let genericMessage = 'Error processing request. Please try again.';


  if (!errObject.response || !errObject.response.data) {
    return genericMessage;
  }

  let err = errObject.response.data;

  
  if (!err.code) {
    return genericMessage;
  }

  let errorList = err.errors;

  if (!errorList || errorList.length < 1) {
    return err.description || genericMessage;
  }


  let message = '<div>Invalid Request.</div>';
  errorList.map((item) => {
    message += '<div>Field "' + item.fieldName + (item.routeField ? '.' + item.routeField : '') + '" : ' + item.message +'</div>';
  });

  return message;
}


// WEBPACK FOOTER //
// ./src/utils/errorProcessor.js